import { getAcceptLanguage } from '@dap/common/utils';
import { BrandadminBaseQueryFn } from '@dap/memberadmin/types';
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { AuthState } from '@shared/state/auth';
import { RoleTags } from './tags';

export const brandadminApiBaseQuery = fetchBaseQuery({
  // Role titles are localized via Accept-Language, but the URL stays the same.
  // Without this, the browser can replay a cached GET from the previous language.
  cache: 'no-store',
  prepareHeaders: (headers, { getState }) => {
    const token = (getState() as { auth: AuthState }).auth.token;

    if (!token) {
      throw new Error('No access token');
    }
    headers.set('authorization', `Bearer ${token}`);
    headers.set('Accept-Language', getAcceptLanguage());
    return headers;
  },
});

export const brandadminApi = createApi({
  reducerPath: 'brandadmin',
  tagTypes: [RoleTags.ROLES],
  baseQuery: brandadminApiBaseQuery as BrandadminBaseQueryFn,
  endpoints: () => ({}),
});
